import { forwardRef } from 'react';
import {
  ProCourseDefaultCertificate,
  type ProCourseDefaultCertificateProps,
} from './ProCourseDefaultCertificate';
import {
  ProCourseFormazioneContinuaSanitaCertificate,
  type ProCourseFormazioneContinuaSanitaCertificateProps,
} from './ProCourseFormazioneContinuaSanitaCertificate';

export type ProCourseCertificateByTemplateProps =
  | ({ templateId: 'cert1' } & ProCourseDefaultCertificateProps)
  | ({ templateId: 'cert3' } & ProCourseDefaultCertificateProps)
  | ({
      templateId: 'cert2';
    } & ProCourseFormazioneContinuaSanitaCertificateProps);

/**
 * Seleziona il componente certificato in base a `templateId`.
 * Aggiungi qui un nuovo `case` quando introduci un literal in `src/types/certificateTemplate.ts`.
 */
export const ProCourseCertificateByTemplate = forwardRef<
  HTMLDivElement,
  ProCourseCertificateByTemplateProps
>(function ProCourseCertificateByTemplate(props, ref) {
  switch (props.templateId) {
    case 'cert1': {
      const { templateId, ...certificateProps } = props;
      void templateId;
      return <ProCourseDefaultCertificate ref={ref} {...certificateProps} />;
    }
    case 'cert3': {
      const { templateId, ...certificateProps } = props;
      void templateId;
      return <ProCourseDefaultCertificate ref={ref} {...certificateProps} />;
    }
    case 'cert2': {
      const { templateId, ...certificateProps } = props;
      void templateId;
      return (
        <ProCourseFormazioneContinuaSanitaCertificate
          ref={ref}
          {...certificateProps}
        />
      );
    }
  }
});
